export default "__VITE_ASSET__HZRb4Jq4__"